const handlePhoneNumberChange = (phone: string, country: {dialCode: string}): {
  phone_number: string
  phone_country_code: string
} => {
  const countryCode = country['dialCode']
  const phoneWithoutCode = phone.startsWith(countryCode)
    ? phone.slice(countryCode.length)
    : phone

  return {
    phone_number: phoneWithoutCode,
    phone_country_code: countryCode
  }
}

export default handlePhoneNumberChange
